/**
 * FR-11.10. Asked on every launch, not once: the grant is not permanent and
 * the answer can change. Whether it was granted is worth knowing — it is the
 * difference between "your evening is safe on this phone" and "it is safe
 * until the browser needs the space".
 */
export interface StorageStatus {
  persisted: boolean;
  quota_bytes: number | null;
  used_bytes: number | null;
}

export async function requestPersistence(): Promise<StorageStatus> {
  let persisted = false;
  try {
    if (navigator.storage?.persisted) persisted = await navigator.storage.persisted();
    if (!persisted && navigator.storage?.persist) persisted = await navigator.storage.persist();
  } catch { /* Safari in a private window throws; the app still works */ }

  let quota: number | null = null, used: number | null = null;
  try {
    const e = await navigator.storage?.estimate?.();
    quota = e?.quota ?? null;
    used = e?.usage ?? null;
  } catch { /* ignore */ }

  return { persisted, quota_bytes: quota, used_bytes: used };
}
